export default function(table, comparator) {
  return table.create({ order: comparator });
}
